const getAccountMenu = () => {
  return Peace.identity.auth.getAccountMenu()
}

const getDynamicRoutes = (accountMenu) => {
  const routeDynamic = [
    {
      path: '/app-intercept',
      name: 'AppIntercept',
      component: () => import('@src/AppIntercept'),
      children: [
        {
          path: '/layout',
          name: 'Layout',
          component: () => import(`@src/layouts/${window.configuration.layout.type}/index.js`),
          children: []
        }
      ]
    }
  ]

  accountMenu?.forEach((route) => {
    if (route.menuPath) {
      const commponent = () =>
        import(`@src/${route.menuPath}/index.js`).catch((error) => {
          console.error(error)

          return import('@src/views/exception/404')
        })

      routeDynamic[0].children[0].children.push({
        path: route.menuRoute,
        name: route.menuAlias,
        meta: Peace.util.deepClone(route),
        component: commponent
      })
    }
  })

  return routeDynamic
}

export default async function() {
  if (Peace.identity.auth.isLogin()) {
    const accountMenu = await getAccountMenu()
    const dynamicRoutes = await getDynamicRoutes(accountMenu)

    return dynamicRoutes
  } else {
    const dynamicRoutes = await getDynamicRoutes([])

    return dynamicRoutes
  }
}
